import React, {useEffect} from 'react'
import {Container, Grid, Typography, MenuItem, TextField} from '@material-ui/core'
import {Query} from 'react-apollo'
import {useTranslation} from 'react-i18next'
import {barcodeSheetQuery} from '../../graphql/barcode/queries/barcodeSheetQuery'
import {barcodeLabelQuery} from '../../graphql/barcode/queries/barcodeLabelQuery'
import {labelWidth, labelHeight} from '../../utils/barcodeSheet'
import {getResolutionFactore} from '../../utils/barcodeSheet'
import BarcodeLabelDragArea from '../BarcodeLabelDragArea'
import BarcodeLabelDropBox from '../BarcodeLabelDropBox'
import BarcodeNavHeaderButtons from '../BarcodeNavHeaderButtons'
import BarcodeLoadingScreen from '../BarcodeLoadingScreen'
import {BarcodeLabelEditorContextProvider} from '../../context/BarcodeLabelEditor'
import useStyles from './BarcodeEditLabel.styles'

function BarcodeEditLabel(props) {
  const {t} = useTranslation()
  const classes = useStyles()
  const accountID = parseInt(window.localStorage.getItem('account_id'))
  const [sheetValue, setSheetValue] = React.useState({})
  const [initialData, setInitialData] = React.useState()
  const [labelValue, setLabelValue] = React.useState({
    id: parseInt(props.match.params.id),
    name: '',
    width: '',
    height: '',
    unit: '',
  })

  const barcodeLabelId = props.match.params.id

  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  function sheetChange(event) {
    let sheet = event.target.value
    setSheetValue(sheet)
    let width = labelWidth(sheet)
    let height = labelHeight(sheet)
    let unit = getUnit(sheet)
    setLabelValue({...labelValue, width, height, unit})
  }

  function labelChange(event) {
    let name = event.target.name
    let value = event.target.value

    setLabelValue({...labelValue, [name]: value})
  }

  function setFetchData(data) {
    if (!data.barcodeLabel) {
      return
    }
    let label = data.barcodeLabel[0]
    var resolutionFactore = getResolutionFactore(label.sheet.unit)
    let keys = Object.keys(label.elements)
    // payload.item = { ...payload.item[itemKey], key: newKey, focused: true }
    let labelElements = keys.map(obj => {
      let value = label.elements[obj]
      value.size.width = value.size.width * resolutionFactore
      value.size.height = value.size.height * resolutionFactore
      value.position.top = value.position.top * resolutionFactore
      value.position.left = value.position.left * resolutionFactore
      value.key = obj
      return {...value}
    })
    setInitialData({labelItems: labelElements})
    // dispatch({type: Actions.INIT, payload: })
    setSheetValue(label.sheet)
    setLabelValue({
      ...labelValue,
      name: label.name,
      width: label.width,
      height: label.height,
      unit: getUnit(label.sheet),
    })
  }

  function setSheets(data) {
    if (sheetValue) {
      let sheet = data.barcodeSheet.find(obj => sheetValue.id === obj.id)
      setSheetValue(sheet)
    }
  }

  function getUnit(sheet) {
    let unit = sheet['unit']
    if (unit === 'in') unit = '(inches)'
    else if (unit === 'mm') unit = '(millimeters)'
    return unit
  }
  return (
    <div>
      <BarcodeNavHeaderButtons previous="" />

      <div>
        <BarcodeLabelEditorContextProvider initialValue={initialData}>
          <Grid container>
            <Grid item xs={5} style={{paddingRight: '4rem'}}>
              <Typography variant="h6" className={classes.headerTitle}>
                {t('barcode.label.edit-label.edit-template')}
              </Typography>
              <Typography className={classes.headerTagLine}>
                {t('barcode.label.edit-label.edit-details')}
              </Typography>
              <Container>
                <Grid container>
                  <Grid container item xs={12} justify="flex-start">
                    <TextField
                      id="name"
                      label={t('barcode.label.edit-label.barcode-sticker')}
                      className={classes.menuBar}
                      fullWidth={true}
                      variant="outlined"
                      name="name"
                      onChange={labelChange}
                      value={labelValue.name}
                    ></TextField>
                  </Grid>
                </Grid>
              </Container>
              <Container>
                <Grid container>
                  <Grid container item xs={12} justify="flex-start">
                    <Query
                      query={barcodeSheetQuery}
                      variables={{accountId: accountID}}
                      onCompleted={data => setSheets(data)}
                      fetchPolicy="network-only"
                    >
                      {({loading, error, data}) => {
                        if (loading)
                          return (
                            <div>
                              <BarcodeLoadingScreen size={50} />
                            </div>
                          )
                        if (error)
                          return (
                            <div>
                              {props.history.push({
                                pathname: 'pageNotFound',
                              })}
                            </div>
                          )
                        return (
                          <TextField
                            id="outlined-select-currency"
                            select
                            label={t('barcode.label.edit-label.sheet')}
                            className={classes.textField}
                            value={sheetValue}
                            onChange={sheetChange}
                            SelectProps={{
                              MenuProps: {
                                className: classes.menu,
                              },
                            }}
                            margin="normal"
                            variant="outlined"
                          >
                            {data.barcodeSheet.map(barcodeSheet => (
                              <MenuItem key={barcodeSheet.id} value={barcodeSheet}>
                                {barcodeSheet.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        )
                      }}
                    </Query>
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid container item xs={6} justify="flex-start">
                    <TextField
                      id="width"
                      label={`${t('barcode.label.edit-label.width')} ${labelValue.unit}`}
                      className={classes.widthField}
                      fullWidth={true}
                      onChange={labelChange}
                      variant="outlined"
                      name="width"
                      value={labelValue.width}
                      disabled
                    ></TextField>
                  </Grid>
                  <Grid container item xs={6} justify="flex-start">
                    <TextField
                      id="height"
                      label={`${t('barcode.label.edit-label.height')} ${labelValue.unit}`}
                      className={classes.heightField}
                      fullWidth={true}
                      onChange={labelChange}
                      variant="outlined"
                      name="height"
                      value={labelValue.height}
                      disabled
                    ></TextField>
                  </Grid>
                </Grid>
              </Container>
              <Container>
                <BarcodeLabelDragArea />
              </Container>
            </Grid>

            <Query
              query={barcodeLabelQuery}
              variables={{accountId: accountID, id: parseInt(barcodeLabelId)}}
              onCompleted={data => setFetchData(data)}
              fetchPolicy="network-only"
            >
              {({loading, error, data}) => {
                if (loading)
                  return (
                    <div>
                      <BarcodeLoadingScreen size={50} />
                    </div>
                  )
                if (error)
                  return (
                    <div>
                      {props.history.push({
                        pathname: 'pageNotFound',
                      })}
                    </div>
                  )
                return (
                  <Grid container item xs={7}>
                    <BarcodeLabelDropBox
                      labelValue={labelValue}
                      sheetValue={sheetValue}
                      edit={true}
                    />
                  </Grid>
                )
              }}
            </Query>
          </Grid>
        </BarcodeLabelEditorContextProvider>
      </div>
    </div>
  )
}
export default BarcodeEditLabel
